export enum InvitationUserTypeEnum {
  NEW = "NEW",
  EXISTING = "EXISTING",
}
